<template>
  <div class="tooltip-box">
    <el-tooltip
      class="item"
      :effect="effect"
      :placement="placement"
      :disabled="isShowTooltip"
      :enterable="enterable"
      :offset="offset"
    >
      <div slot="content" :style="`max-width: ${showTextWidth};`">{{textName}}</div>
      <p class="content-text" :style="`max-Width: ${textWidth}; max-height: ${textHeight}; -webkit-line-clamp: ${textRow};`" @mouseover="onMouseOver(textRef, textId)">
        <span :ref="`${textRef}${textId}`">{{textName}}</span>
      </p>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'tooltip-box',
  props: {
    // 超出显示的宽：默认 '800'
    showTextWidth: {
      type: String,
      default: '800px'
    },
    // 文本宽
    textWidth: {
      type: String,
      default: '100%'
    },
    // 文本高
    textHeight: {
      type: String,
      default: '100%'
    },
    // 文本行：默认 '1'
    textRow: {
      type: Number,
      default: 1
    },
    // 文本标识名称：默认 'text'
    textRef: {
      type: String,
      default: 'text'
    },
    // 文本标识id
    textId: {
      type: String,
      default: '666'
    },
    // 文本: 必传
    textName: {
      type: String,
      default: ''
    },
    // 浮窗样式：dark/light：默认 'light'
    effect: {
      type: String,
      default: 'light'
    },
    // 悬浮位置：top/top-start/top-end/bottom/bottom-start/bottom-end/left/left-start/left-end/right/right-start/right-end
    placement: {
      type: String,
      default: 'bottom'
    },
    // Tooltip 是否开启超出显示: 默认 false开启超出浮窗，true则不超出也显示浮窗
    tooltipShow: {
      type: Boolean,
      default: false
    },
    // 鼠标是否可进入到tooltip中： 默认 false不可进入
    enterable: {
      type: Boolean,
      default: false
    },
    // 出现位置的偏移量
    offset: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      isShowTooltip: false, // 默认显示
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  methods: {
    onMouseOver(name, datasetId) {
      let parentWidth = 0,
        contentWidth = 0,
        parentHeight = 0,
        contentHeight = 0;

      parentWidth = this.$refs[`${name}${datasetId}`].parentNode.offsetWidth;
      contentWidth = this.$refs[`${name}${datasetId}`].offsetWidth;
      parentHeight = this.$refs[`${name}${datasetId}`].parentNode.offsetHeight;
      contentHeight = this.$refs[`${name}${datasetId}`].offsetHeight;

      // 判断为true则不超出也显示文本浮窗
      if (this.tooltipShow) {
        return
      }
      // 判断是否开启tooltip功能
      if (contentWidth > parentWidth || contentHeight > parentHeight) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
      // this.$forceUpdate();
    },
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="scss" scoped>
.tooltip-box {
  .content-text {
    box-sizing: border-box;
    text-align: justify;
    text-justify: newspaper;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
}
</style>

<style>
  .el-tooltip__popper.is-light {
    border: 1px solid #ccc !important;
  }
  .el-tooltip__popper .popper__arrow {
    /* 上方箭头 */
    border-top-color: #ccc !important;
    /* 下方箭头 */
    border-bottom-color: #ccc !important;
  }
  .el-tooltip__popper .popper__arrow::after {
    /* 上方箭头 */
    border-top-color: #fff !important;
    /* 下方箭头 */
    border-bottom-color: #fff !important;
  }
</style>